import { useNavigate } from "react-router-dom";
import SingleSelectKendoGrid from "../../../Grid/Selectable/SingleSelectKendoGrid";
import { TTProtectionColumns } from "./TTProtectionColumns";
import { ttProtectionUrls } from "../../../URL/ApplicationUrls";
import { combinedUrls } from "../../../URL/functions";
import PageHeader from "../../../Layout/Header/PageHeader";
import { defaultAddButton } from "../../../Grid/Toolbar/DefaultAddButton";
import { defaultEditButton } from "../../../Grid/Toolbar/DefaultEditButton";
import { TTProtectionOverviewToolbarMenu } from "./TTProtectionOverviewToolbarMenu";
import { TTProtectionOverviewItem } from "./TTProtectionOverviewItem";
import { AuthorizationPolicies } from "../../../Auth/AuthorizationPolicy";

export const TTProtectionOverview = () => {
  const navigate = useNavigate();

  const addTTProtection = () => navigate(ttProtectionUrls.addTTProtection.uiPath);

  const editTTProtection = (ttProtection: TTProtectionOverviewItem | undefined) =>
    ttProtection && navigate(ttProtectionUrls.detailsFor(ttProtection.PNr));

  const url = combinedUrls(ttProtectionUrls.base.apiUrl, "KendoGrid");

  return (
    <>
      <PageHeader headerText="Transit Time Protection" />
      <SingleSelectKendoGrid
        localStorageKey="TTProtectionOverviewGrid_DataState"
        fetchUrl={url}
        initialSorting={{ field: "PNr", dir: "desc" }}
        columns={TTProtectionColumns()}
        idSelector={(it: TTProtectionOverviewItem) => it.PNr}
        toolbarItems={[
          defaultAddButton({
            onClick: addTTProtection,
            roles: AuthorizationPolicies.RequireAdminRiskmanagerRoles,
          }),
          defaultEditButton({
            onClick: editTTProtection,
            roles: AuthorizationPolicies.RequireAdminRiskmanagerRoles,
          }),
        ]}
        onRowDoubleClick={editTTProtection}
        customToolbarItems={[TTProtectionOverviewToolbarMenu(url)]}
      />
    </>
  );
};
